module.exports = __webpack_public_path__ + "img/blip_builder_white.8e1e0b36.svg";